import { createClientUuid } from "../createClientUuid";

const streamSessionIds = new Map<string, string>();

export function getOrCreateRecsysStreamSessionId(streamId: string): string {
  const existing = streamSessionIds.get(streamId);
  if (existing) {
    return existing;
  }

  const nextId = createClientUuid();
  streamSessionIds.set(streamId, nextId);
  return nextId;
}

export function clearRecsysStreamSessionId(streamId?: string): void {
  if (!streamId) {
    return;
  }

  streamSessionIds.delete(streamId);
}
